// noinspection JSUnresolvedVariable

import {genRandomString, OktaAuth} from "@okta/okta-auth-js";
import oktaAuthConfig from "./config";
import {axiosInstance} from "../../api/base";

export const oktaAuth = new OktaAuth(oktaAuthConfig);

const onAuthUpdateState = {
	lastAccessToken: null,
	observers: {},
};

export const addOnAuthUpdate = (observer = () => {}) => {
	let observerId = genRandomString(16);

	while(Object.keys(onAuthUpdateState.observers).indexOf(observerId) > -1) {
		observerId = genRandomString(16);
	}

	onAuthUpdateState.observers[observerId] = observer;

	return observerId;
}

export const removeOnAuthUpdate = (observerId) => {
	if(Object.keys(onAuthUpdateState.observers).indexOf(observerId) > -1) {
		delete onAuthUpdateState.observers[observerId];
	}
}

oktaAuth.authStateManager.subscribe(({accessToken}) => {
	if(accessToken !== onAuthUpdateState.lastAccessToken) {
		const observers = Object.keys(onAuthUpdateState.observers);

		for (const key of observers) {
			onAuthUpdateState.observers[key](accessToken);
		}

		onAuthUpdateState.lastAccessToken = accessToken;
	}
})

addOnAuthUpdate((accessToken) => {
	if(accessToken?.accessToken) {
		axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken?.accessToken}`;
	}
	else {
		delete axiosInstance.defaults.headers.common['Authorization'];
	}
})
